/* @flow */
import * as React from "react";
import posed, { PoseGroup } from "react-pose";
import prefixStyles from "nx-components/utils/prefixStyles";
import ToastMsg from "nexia_mobile/components/Toaster/ToastMsg";

const style = prefixStyles({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const DRAG_LIMIT = 80;

type PosedToastMsgProps = $Diff<
  React.ElementProps<typeof ToastMsg>,
  {
    hostRef: (?HTMLElement) => mixed,
  }
> & {
  onDragEnd: () => void,
  onValueChange: {
    x: (number) => mixed,
  },
};
const PosedToastMsg: React.ComponentType<PosedToastMsgProps> = posed(ToastMsg)({
  // The ToastMsg div styl must match this because it will be treated as an "initial" state
  preEnter: {
    opacity: 0,
    height: 0,
    x: "-100vw",
  },
  enter: {
    opacity: 1,
    height: "auto", // 🎉
    x: 0,
  },
  exit: {
    opacity: 0,
    height: 0,
    // no "x" so that the dragEnd transition for "x" isn't overridden
  },
  /* Modified heavily from https://codepen.io/stolinski/pen/WJEQzw */
  draggable: "x",
  dragEnd: {
    transition: {
      x: (props) => {
        if (Math.abs(props.from) > DRAG_LIMIT) {
          // Toast is being dismissed, just continue at the current velocity
          return { type: "physics" };
        } else {
          return { type: "spring" };
        }
      },
    },
  },
  /* End of borrowed code */
});

export type toast = {
  id: number,
  message: string,
  persistent: boolean,
};

type Props = {
  toasts: {
    [id: string]: toast,
  },
  onDismissToast: (number) => void,
};

type State = {
  poseKey: number,
};

export default class Toast extends React.Component<Props, State> {
  _toastPositions: Map<number, number> = new Map();

  _mapToasts = <To>(mapper: (toast) => To): Array<To> => {
    const { toasts } = this.props;
    return ((Object.values(toasts): any): Array<toast>).map(mapper);
  };

  render() {
    const { onDismissToast } = this.props;
    const toastMessages = this._mapToasts(({ id, message, persistent }) => {
      return (
        <PosedToastMsg
          key={id}
          id={id}
          persistent={persistent}
          text={message}
          onDismiss={() => onDismissToast(id)}
          onValueChange={{ x: (x) => this._toastPositions.set(id, x) }}
          onDragEnd={() => {
            let currentX = this._toastPositions.get(id);
            if (currentX && Math.abs(currentX) > DRAG_LIMIT) {
              this._toastPositions.delete(id);
              onDismissToast(id);
            }
          }}
        />
      );
    });

    return (
      <div data-component-name="Toast" style={style}>
        <PoseGroup preEnterPose="preEnter">{toastMessages}</PoseGroup>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Toaster/Toast.jsx